// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CardDraftLabel_wrapper__EdbGY"};